import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { APP_PATHS } from "../../../../../../../constants/paths";
import { SKUS_QUERY_STRING } from "../../../../../../../constants/skus";
import classes from "./MegaDropdownList.module.css";

const MegaDropdownList = (props) => {
  const { categoryName, categoryId, subCategories, closeMegaMenu } = props;

  return (
    <div className={classes["mega-dropdown-list"]}>
      <h3 className={classes["mega-dropdown-list__header"]}>{categoryName}</h3>
      <nav>
        <ul className={classes["mega-dropdown-list__nav-list"]}>
          {subCategories.map((subCategory, index) => (
            <li key={index} className={classes["mega-dropdown-list__nav-item"]}>
              <Link
                to={`${APP_PATHS.SKUS.url}?${SKUS_QUERY_STRING.CATEGORY_NAME}=${categoryName}&${SKUS_QUERY_STRING.CATEGORY_ID}=${categoryId}&${SKUS_QUERY_STRING.SUB_CATEGORY_ID}=${subCategory.id}`}
                onClick={closeMegaMenu}
              >
                {subCategory.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default MegaDropdownList;

MegaDropdownList.propTypes = {
  categoryName: PropTypes.string,
  categoryId: PropTypes.number,
  subCategories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number,
    })
  ),
  closeMegaMenu: PropTypes.func,
};
